module.exports = "pegasus_template/assets/lp/travel/bg0.png";